var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 1.01121C25.5 1.01121 23.2985 2.33981 22.0745 2.71654C21.4175 1.9447 20.5444 1.39763 19.5731 1.14934C18.6019 0.901042 17.5795 0.963498 16.6441 1.32826C15.7087 1.69302 14.9056 2.34249 14.3433 3.18882C13.7809 4.03515 13.4866 5.03751 13.5 6.06034V7.17494C11.5829 7.22573 9.68321 6.79131 7.97019 5.91037C6.25717 5.02942 4.78398 3.72931 3.68182 2.12581C3.68182 2.12581 -0.681818 12.1572 9.13636 16.6156C6.88967 18.1738 4.21326 18.9551 1.5 18.8448C11.3182 24.4178 23.3182 18.8448 23.3182 6.0269C23.3182 5.71704 23.2876 5.40718 23.2309 5.10178C24.3436 3.9805 25.5 1.01121 25.5 1.01121Z",
    stroke: "url(#paint0_linear_641_5197)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_5197",
    x1: 3.27378,
    y1: 11.3575,
    x2: 25.9197,
    y2: 12.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61008F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1dc8e1a7ad273a5a2ac9a7221012f034.svg";
export { ForwardRef as ReactComponent };